import React from 'react';

import AppButton from '../../../designe/app-button/AppButton';
import { useTranslation } from 'react-i18next';
import { RelationStatus } from '../../../../shared/constants';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../../../shared/paths';
import { AvatarTypes } from '../../../designe/app-avatar/AppAvatar';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../designe/app-entity-avatar/AppEntityAvatar';
import { useGetMyDetails } from '../../../../services/redux/api/usersApi';
import { useStyles } from './UserBigItem.styles';
import theme from '../../../../styles/theme';
import { useUserBigItem } from './useUserBigItem';
import { IUser } from '../../../../types/interfaces/user';

interface UserBigItemProps {
  user: IUser;
  showStatusButton?: boolean;
  communityId?: string; // one day to do it better. Now I am tired and lazy
}

export default function UserBigItem(props: UserBigItemProps) {
  const { user, showStatusButton, communityId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: currentUser } = useGetMyDetails();
  const isCurrentUser = user.id === currentUser.id;
  const { classes } = useStyles(theme);
  const {
    onSubscribe,
    onUnsubscribe,
    onSubscriptionStatusChange,
    subscribeActions,
  } = useUserBigItem(user, showStatusButton, communityId);

  function clickOnUserHandler() {
    navigate(`${Paths.users.root}/${user.id}`);
  }

  return (
    <div className={classes.userWrapper} onClick={clickOnUserHandler}>
      <div className={classes.avatarWrapper}>
        <AppEntityAvatar
          entity={user}
          size={AvatarSize.l}
          type={AvatarTypes.round}
        />
      </div>
      <div className={classes.userDetails}>
        <div className={classes.infoWrapper}>
          <div
            className={
              classes.infoName
            }>{`${user.firstname} ${user.lastname}`}</div>
        </div>
        <div
          className={classes.controlWrapper}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}>
          {!isCurrentUser && (
            <>
              {subscribeActions.includes('subscribe') && (
                <AppButton onClick={() => onSubscribe(user.id)}>
                  {t('usersList.subscribe')}
                </AppButton>
              )}
              {subscribeActions.includes('unsubscribe') && (
                <AppButton
                  variant="outlined"
                  onClick={() => onUnsubscribe(user.id)}>
                  {t('usersList.unsubscribe')}
                </AppButton>
              )}
              {subscribeActions.includes('approve') && (
                <AppButton
                  color="success"
                  onClick={() =>
                    onSubscriptionStatusChange(user.id, RelationStatus.approved)
                  }>
                  {t('usersList.approve')}
                </AppButton>
              )}
              {subscribeActions.includes('reject') && (
                <AppButton
                  color="error"
                  variant="outlined"
                  onClick={() =>
                    onSubscriptionStatusChange(user.id, RelationStatus.rejected)
                  }>
                  {t('usersList.reject')}
                </AppButton>
              )}
              {subscribeActions.includes('dropFromSubscribers') && (
                <AppButton
                  variant="outlined"
                  color="error"
                  onClick={() =>
                    onSubscriptionStatusChange(user.id, RelationStatus.rejected)
                  }>
                  {t('usersList.dropFromSubscribers')}
                </AppButton>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
